import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private auth: AuthService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (
			this.auth.user() &&
			request['url'].includes('api-secure.kurdshopping') &&
			!request['url'].includes('/login') &&
			!request['url'].includes('/register')
		) {
			const modifiedRequest = request.clone({ headers: request.headers.append('Authorization', 'Bearer ' + this.auth.user()['token']) });
			return next.handle(modifiedRequest);
		} else {
			return next.handle(request);
		}
	}
}
